import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { InstanceAssetType } from '../Modules/management/models/instance/instance-asset-type.model';
import { UserMatrixModel } from '../Modules/informate/models/user-matrix-model';
import { UserMatrixRowModel } from '../Modules/informate/models/user-matrix-row-model';
import { SharedContentCategory } from '../Modules/settings/enums/shared-content-category.enum';
import { SharedContentCategoryModel } from '../Modules/settings/models/general/shared-content-category-model';
import { SharedContentModel } from '../Modules/settings/models/general/shared-content-model';
import { SharedContentTypeModel } from '../Modules/settings/models/general/shared-content-type-model';
import { SettingModel, SettingValueModel, UserSettingModel } from '../Modules/settings/models/informate';
import {
    InstanceForDashboard,
    InstanceModel,
    InstanceType,
    InstanceUsers,
    TaggedItemType,
    ViewDto,
} from '../Modules/management/models/instance/instance.model';
import { DeleteSecurityRole, PermissionActions, PermissionHierarchy } from '../Modules/management/models/organization/security-role-permission.model';
import { OrganizationUserModel } from '../Modules/management/models/organization/organization-user.model';
import { LicenseType } from '../Modules/management/models/organization/license-type.model';
import { Organization, OrgnaizationForDashboard, UserInstanceModel, profileContactModel } from '../Modules/management/models/organization/organization.model';
import { UserDefaultModel } from '../models/user-default-model';
import { UserPermissions } from '../Modules/management/models/organization/user-permissions.model';
import { ResultType } from '../models/enums/result-type.enum';
import { AddUserType } from '../Modules/management/models/organization/UserType.model';
import { User } from '../Modules/management/models/organization/user.model';
import { B2CUser } from '../Modules/management/models/organization/fedratedOrganizationUser.model';
import { AdUserValidationResp } from '../Modules/management/models/organization/adUserValidationResp.model';
import { MatrixRowModel } from '../Modules/informate/models/templatesModels/matrix-row-model';
import { FullUserData } from '../Modules/management/models/organization/fullUserData.model';
import { EmailModel } from '../models/email.model';
import { TranslocoService } from '@jsverse/transloco';
import { Languages } from '../shared/enums/language.enum';
import { Notifications } from '../models/Notifications.model';
import { Communication, SystemMaintenanceModel } from '../Modules/settings/models/profile/communication.model';
import {
    ActivityIcon,
    ActivityPackType,
    ActivityStatusType,
    ActivityTagStandard,
    Activitypacktypestatusfunctions,
    DeleteActivityTypesPayload,
} from '../Modules/management/models/instance/activity-pacck-type.model';
import { InstanceDataService } from './instance-data.service';
import { DeleteProjectType, ProjectType, ProjectTypeStatus, SchemaVersion } from '../Modules/management/models/instance/project-type.model';
import { LineNumberFormat, LineNumberFormatSectionType } from '../Modules/management/models/instance/line-number-format.model';
import { HierarchyViewModel } from '../Modules/idms/models/hierarchy-view.model';
import { ApprovalDeliveryGroupModel, SettingArea } from '../Modules/settings/models/common/setting-area.model';
import { APIRes } from '../Modules/idms/models/commonAPI.model';
import { ReportList } from '../Modules/informate/models/reports/data-sheet-report.model';
import { UserSessions } from '../models/user-sessions-details';
import { environment } from 'src/environments/environment';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AzureDetailsModel } from '../Modules/management/models/organization/azureDetailsModel.model';
import { InstancesContext } from '../Modules/management/models/instance/instance-contexts.model';

import { DefaultInstanceSettings, InstanceSettings } from '../Modules/management/models/instance/instace-setting.model';
import { AnyAaaaRecord } from 'dns';
import { ViewType } from '../Modules/idms/components/idms/idms-site-search/models/ViewTpesModel';
import { EnvironmentService } from './environment.service';

@Injectable({
    providedIn: 'root',
})
export class ManagementApiService {
    private mgmtApi = environment.mgmtApi;
    private subVal = '';
    private anonymousApi = environment.anonymousApi;
    private anonymousEmailApi = environment.anonymousEmailApi;
    private logedInUserId = this.authService?.instance?.getActiveAccount()?.idTokenClaims?.oid;

    headers: HttpHeaders;
    userDefaults: UserDefaultModel[];
    sharedContentCategories: SharedContentCategoryModel[];
    userDetails: User;

    constructor(
        private http: HttpClient,
        private authService: MsalService,
        private datepipe: DatePipe,
        private translocoService: TranslocoService,
        private globalEmittersService: GlobalEmittersService,
        private instanceDataService: InstanceDataService,
        private EnvironmentService: EnvironmentService,
        private appInsights: ApplicationInsights
    ) {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        var _config = EnvironmentService.getConfig();
        this.subVal = _config.subValue;
        this.postLogin();
    }

    async postLogin() {
        this.logedInUserId = this.authService?.instance?.getActiveAccount()?.idTokenClaims?.oid;
        if (this.logedInUserId) {
            this.getUserDefaults()
                .toPromise()
                .then(
                    (userDefaults) => {
                        if (userDefaults.success) {
                            this.userDefaults = userDefaults.response;
                            let selectLang = this.userDefaults?.find((x) => x.userPreferenceKey == 'DefaultLanguage').userPreference;
                            this.translocoService.setActiveLang(Languages[selectLang]);
                            this.globalEmittersService.isUserDefaultsLoaded.next(true);
                            this.translocoService.load(Languages[selectLang]);
                        } else if (userDefaults.isCustom) {
                            this.globalEmittersService.isUserDefaultsLoaded.next(false);
                        }
                    },
                    (err) => {
                        this.globalEmittersService.isUserDefaultsLoaded.next(false);
                    }
                );

            this.getUser().subscribe((userModel) => {
                this.userDetails = userModel.response;
                this.instanceDataService.userDetails.next(this.userDetails);
            });

            this.asyncGetSharedContentCategories();
        }
    }

    addPostAndPutHeaders() {
        this.headers = new HttpHeaders();
        this.headers = this.headers.append('Ocp-Apim-Subscription-Key', this.subVal);
        this.headers = this.headers.append('content-type', 'application/json');
        this.headers = this.headers.append('Accept', 'application/json');
        this.headers = this.headers.append('Access-Control-Allow-Origin', '*');
        this.headers = this.headers.append('Content-Type', 'multipart/form-data');
        this.headers = this.headers.append('Authorization', `Bearer ${localStorage.getItem('msal.accessToken')}`);
    }

    addDemoUser(): Observable<APIRes<FullUserData>> {
        this.addPostAndPutHeaders();
        return this.http.post(this.mgmtApi + 'users/adddemouser', {}, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getUserPermissions(): Observable<APIRes<UserPermissions[]>> {
        this.logedInUserId = this.authService?.instance?.getActiveAccount()?.idTokenClaims?.oid;
        this.addPostAndPutHeaders();
        return this.http.get(`${this.mgmtApi}UserPermissions/${this.logedInUserId}`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getUserDefaults(): Observable<APIRes<UserDefaultModel[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.mgmtApi}usersettings/getuserdefaults?userid=${this.logedInUserId}`, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    getUser(): Observable<APIRes<User>> {
        return this.http.get(`${this.mgmtApi}Users/` + this.logedInUserId, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getUserSettings(): Observable<APIRes<UserSettingModel[]>> {
        return this.http
            .get(`${this.mgmtApi}usersettings/getusersettings/?userid=${this.logedInUserId}`, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    getSettings(): Observable<APIRes<SettingModel[]>> {
        return this.http
            .get(`${this.mgmtApi}Settings`, { headers: this.headers, params: new HttpParams().set('TypeIndex', '4') })
            .pipe(catchError(this.handleError.bind(this)));
    }

    updateUserSettings(settings: any[]): Observable<APIRes<SettingModel[]>> {
        const inputMsg = JSON.stringify(settings);
        this.addPostAndPutHeaders();
        return this.http
            .put(`${this.mgmtApi}usersettings/updateusersettings`, inputMsg, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    getMatrices(includeMatrixRows: boolean): Observable<APIRes<UserMatrixModel[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.mgmtApi}UserMatrices`, {
                headers: this.headers,
                params: new HttpParams().set('userMatrixUsage', '1').set('includeMatrixRows', includeMatrixRows == true ? 'true' : 'false'),
            })
            .pipe(catchError(this.handleError.bind(this)));
    }

    getUserMatrixRows(matrixId: string): Observable<APIRes<UserMatrixRowModel[]>> {
        return this.http
            .get(`${this.mgmtApi}UserMatrixRows/GetUserMatrixRows/` + matrixId, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    createMatrix(userMatrix: UserMatrixModel): Observable<APIRes<UserMatrixModel[]>> {
        this.addPostAndPutHeaders();
        let inputMsg = JSON.stringify(userMatrix);
        return this.http.post(this.mgmtApi + 'UserMatrices', inputMsg, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    updateMatrix(userMatrix: UserMatrixModel): Observable<APIRes<UserMatrixModel>> {
        this.addPostAndPutHeaders();
        let inputMsg = JSON.stringify(userMatrix);
        return this.http.put(this.mgmtApi + 'UserMatrices', inputMsg, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    removeMatrix(userMatrixId: string): Observable<APIRes<UserMatrixModel[]>> {
        return this.http.delete(this.mgmtApi + 'UserMatrices/' + userMatrixId, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    createMatrixRow(userMatrixRow: UserMatrixRowModel): Observable<APIRes<MatrixRowModel[]>> {
        this.addPostAndPutHeaders();
        let inputMsg = JSON.stringify(userMatrixRow);
        return this.http.post(this.mgmtApi + 'UserMatrixRows', inputMsg, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    updateMatrixRow(userMatrixRow: UserMatrixRowModel[]): Observable<APIRes<MatrixRowModel[]>> {
        this.addPostAndPutHeaders();
        let inputMsg = JSON.stringify(userMatrixRow);
        return this.http.put(this.mgmtApi + 'UserMatrixRows', inputMsg, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getSharedContents(categoryKey: SharedContentCategory, languageId: string, languageAbbrv: string): Observable<APIRes<SharedContentModel[]>> {
        let params: HttpParams;
        if (languageId !== null) {
            params = this.createHttpParams({ SharedContentCategoryKey: categoryKey, Language: languageId });
        } else {
            params = this.createHttpParams({ SharedContentCategoryKey: categoryKey, LanguageAbbreviation: languageAbbrv?.split('-')[0] });
        }
        this.addPostAndPutHeaders();
        return this.http.get(`${this.mgmtApi}SharedContents`, { headers: this.headers, params: params }).pipe(catchError(this.handleError.bind(this)));
    }

    getCategoryId(category: SharedContentCategory): string {
        let categoryId = this.sharedContentCategories.find((x) => x.key == category).sharedContentCategoryId;
        return categoryId;
    }

    // * get the sharedContents data only for landing page
    getSharedContentForLandingPage(categoryKey: SharedContentCategory, languageAbbrv: string): Observable<APIRes<SharedContentModel[]>> {
        this.addPostAndPutHeaders();
        let queryParams = this.createHttpParams({ SharedContentCategoryKey: categoryKey, LanguageAbbreviation: languageAbbrv?.split('-')[0] });
        return this.http
            .get(`${this.anonymousApi}SharedContents/GetSharedContentsForLandingPage`, { params: queryParams, headers: this.headers })
            .pipe(catchError(this.handleError.bind(this))); //* App Insights
    }

    // * api to get the sharedContent only for image
    getSharedContentForHomePage(categoryKey: SharedContentCategory, languageAbbrv: string): Observable<APIRes<SharedContentModel[]>> {
        let queryParams = this.createHttpParams({ SharedContentCategoryKey: categoryKey, LanguageAbbreviation: languageAbbrv?.split('-')[0] });
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.mgmtApi}SharedContents/GetSharedContentsForHomePage`, { headers: this.headers, params: queryParams })
            .pipe(catchError(this.handleError.bind(this)));
    }

    createSharedContent(sharedContent: SharedContentModel, category: SharedContentCategory): Observable<APIRes<SharedContentModel[]>> {
        let headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        let payload = this.createSharedContentPayload(sharedContent, category);
        return this.http.post(this.mgmtApi + 'SharedContents', payload, { headers: headers }).pipe(catchError(this.handleError.bind(this)));
    }

    removeSharedContent(sharedContentId: string): Observable<APIRes<SharedContentModel[]>> {
        return this.http.delete(this.mgmtApi + 'SharedContents/' + sharedContentId, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    private createSharedContentPayload(sharedContent: SharedContentModel, category: SharedContentCategory) {
        const payload = new FormData();
        payload.append('sharedContent[sharedContentCategoryId]', this.getCategoryId(category));
        if (sharedContent.sharedContentId && sharedContent.sharedContentId !== null) {
            payload.append('sharedContent[sharedContentId]', sharedContent.sharedContentId);
        }

        if (sharedContent.sharedContentTypeId && sharedContent.sharedContentTypeId !== null)
            payload.append('sharedContent[sharedContentTypeId]', sharedContent.sharedContentTypeId);

        payload.append('sharedContent[heading]', sharedContent.heading);
        payload.append('sharedContent[subHeading]', sharedContent.subHeading);
        payload.append('sharedContent[navigationText]', sharedContent.navigationText);
        payload.append('sharedContent[navigationLink]', sharedContent.navigationLink);
        payload.append('sharedContent[Language]', sharedContent.language.settingValueId);

        if (sharedContent.date !== undefined && sharedContent.date !== null)
            payload.append('sharedContent[date]', this.datepipe.transform(sharedContent.date, 'yyyy-MM-dd hh:mm:ss'));
        if (sharedContent.imageBlob && sharedContent.imageFileName) {
            payload.append('File', sharedContent.imageBlob, sharedContent.imageFileName);
        }
        if (sharedContent?.imageLocation > 0) {
            payload.append('sharedContent[ImageLocation]', sharedContent.imageLocation as unknown as Blob);
        }
        if (sharedContent.isPurchase === true) {
            payload.append('sharedContent[isPurchase]', 'true');
            payload.append('sharedContent[price]', sharedContent.price);
        }
        return payload;
    }

    updateSharedContent(sharedContent: SharedContentModel, category: SharedContentCategory): Observable<APIRes<SharedContentModel[]>> {
        let headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http
            .put(this.mgmtApi + 'SharedContents', this.createSharedContentPayload(sharedContent, category), { headers: headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    getSharedContentCategories(): Observable<APIRes<SharedContentCategoryModel[]>> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.mgmtApi}SharedContentCategories`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    async asyncGetSharedContentCategories() {
        if (!this.sharedContentCategories) {
            let res = await this.getSharedContentCategories().toPromise();
            if (res.success) {
                this.sharedContentCategories = res.response;
            }
        }
    }

    getSharedContentTypes(categoryKey: string): Observable<APIRes<SharedContentTypeModel[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.mgmtApi}SharedContentTypes/GetSharedContentTypes/` + categoryKey, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    getSettingValues(settingId: string, settingKey: string): Observable<SettingValueModel[]> {
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.mgmtApi}SettingValues/GetSettingValues`, {
                headers: this.headers,
                params: new HttpParams().set('settingId', settingId).set('settingKey', settingKey),
            })
            .pipe(catchError(this.handleError.bind(this)));
    }

    private extractResultType(statusCode: number): ResultType {
        if (statusCode >= 200 || statusCode < 300) {
            return ResultType.Success;
        } else {
            return ResultType.Error;
        }
    }

    private createHttpParams(params: {}): HttpParams {
        let httpParams: HttpParams = new HttpParams();
        Object.keys(params).forEach((param) => {
            if (params[param]) {
                httpParams = httpParams.set(param, params[param]);
            }
        });

        return httpParams;
    }

    private handleError(error: any) {
        this.logedInUserId = this.authService?.instance?.getActiveAccount()?.idTokenClaims?.oid;
        let currOrg = localStorage.getItem('selectedOrgId');
        let currInstance = localStorage.getItem('currentInstanceId');
        if (error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.message);

            this.appInsights.trackException({
                exception: new Error(error.message),
                properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.logedInUserId },
            });
            this.appInsights.trackPageView({
                properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.logedInUserId },
            });
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong.
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.message}`);
            this.appInsights.trackException({
                exception: new Error(error.message),
                properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.logedInUserId },
            });
            //  this.appInsights.trackPageView({ properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.logedInUserId } });
        }
        // Return an observable with a user-facing error message.
        return throwError('Something bad happened; please try again later.');
    }

    async refreshUserDefaults() {
        //Refresh the user defaults post Update.
        this.getUserDefaults().subscribe((userDefaults) => {
            [(this.userDefaults = userDefaults.response)];
        });
    }

    addOrganization(organizationData: FormData): Observable<APIRes<Organization>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http.post(`${this.mgmtApi}Organisations`, organizationData, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    updateOrganization(organizationData: FormData): Observable<APIRes<Organization>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http.put(`${this.mgmtApi}Organisations`, organizationData, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getUsersForOrganization(orgID: string, includeCrossOrganisationInstanceUsers?: boolean): Observable<APIRes<OrganizationUserModel[]>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        let url = '';
        if (includeCrossOrganisationInstanceUsers) {
            url = `${this.mgmtApi}B2CUsers/getLocalOrganizationUsers/${orgID}?includeCrossOrganisationInstanceUsers=true`;
        } else {
            url = `${this.mgmtApi}B2CUsers/getLocalOrganizationUsers/${orgID}`;
        }
        return this.http.get(url, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getOrganizations(): Observable<APIRes<OrgnaizationForDashboard[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.mgmtApi}Organisations/GetOrganisationsForDashboard`, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    getOrganizationById(orgId: string): Observable<APIRes<Organization>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http.get(`${this.mgmtApi}Organisations/${orgId}`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getDataForAutoComplete(searchString: string, inputName: string): Observable<APIRes<profileContactModel[]>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http
            .get(`${this.mgmtApi}ProfileContacts/SearchProfileContacts/${inputName}/${searchString}`, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    testAzureADConnection(azureADDetails: AzureDetailsModel): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http
            .post(`${this.mgmtApi}B2CUsers/testAzureB2CConnection`, azureADDetails, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    getLicenseType(): Observable<APIRes<LicenseType[]>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http.get(`${this.mgmtApi}LicenseTypes`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    validateAzureADB2cUser(email: string): Observable<APIRes<AdUserValidationResp>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http.get(`${this.mgmtApi}B2CUsers/getLocalUser/${email}`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    validateFederatedAdB2cUser(orgId: string, userEmail: string): Observable<APIRes<any>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http
            .get(`${this.mgmtApi}B2CUsers/getFederatedUser/${orgId}/${userEmail}`, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    addUserTypes(userType: AddUserType[]): Observable<APIRes<PermissionHierarchy[]>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http.post(`${this.mgmtApi}SecurityRoles`, userType, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // getUserTypeByOrgId(orgId: string): Observable<APIRes<PermissionHierarchy[]>> {
    //     this.addPostAndPutHeaders();
    //     let queryParams = new HttpParams().set('organisationId', orgId);
    //     return this.http.get(`${this.mgmtApi}SecurityRoles`, { headers: this.headers, params: queryParams }).pipe(catchError(this.handleError.bind(this)));
    // }

    updateUserType(updatedUserTypeData: any): Observable<APIRes<PermissionHierarchy[]>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http.put(`${this.mgmtApi}SecurityRoles`, updatedUserTypeData, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    addOrganizationUser(organizationUser: FormData): Observable<APIRes<User>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http.post(`${this.mgmtApi}Users`, organizationUser, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    updateOrganizationUser(organizationUser: FormData): Observable<APIRes<PermissionHierarchy[]>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http.put(`${this.mgmtApi}users`, organizationUser, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    deleteOrganizationUser(userId: string): Observable<APIRes<User>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http.delete(`${this.mgmtApi}users/${userId}`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    addB2CUser(b2cUser): Observable<APIRes<B2CUser>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http.post(`${this.mgmtApi}B2CUsers/addLocalUser`, b2cUser, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    addFederatedUserTOB2C(b2cUSer): Observable<APIRes<B2CUser>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http.post(`${this.mgmtApi}B2CUsers/addFederatedUser`, b2cUSer, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //instance related API's
    getInstanceAssetType(): Observable<APIRes<InstanceAssetType[]>> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.mgmtApi}instanceassettypes`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getInstanceContext(): Observable<APIRes<InstancesContext[]>> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.mgmtApi}instancecontexts`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
        // return this.http.get('https://idmswebapi.azure-api.net/mgmt-api-dev/api/instancecontexts');
    }

    getInstanceTypes(): Observable<APIRes<InstanceType[]>> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.mgmtApi}InstanceTypes`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    addInstance(instanceData: FormData): Observable<APIRes<InstanceModel>> {
        this.headers = new HttpHeaders({
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
            'Ocp-Apim-Subscription-Key': this.subVal,
        });
        return this.http.post(`${this.mgmtApi}instances`, instanceData, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    updateInstance(instanceData: FormData): Observable<APIRes<InstanceModel>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http.put(`${this.mgmtApi}instances`, instanceData, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getInstanceByOrgId(orgId: string): Observable<APIRes<InstanceForDashboard[]>> {
        this.addPostAndPutHeaders();
        let queryParams = new HttpParams().set('organisationId', orgId);
        return this.http
            .get(`${this.mgmtApi}Instances/getInstancesForDashboard`, { params: queryParams, headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    getInstanceById(instanceId: string): Observable<APIRes<InstanceModel>> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.mgmtApi}Instances/${instanceId}`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getSecurityRolesPermissionTemplate(includePermission: boolean): Observable<APIRes<PermissionHierarchy[]>> {
        this.addPostAndPutHeaders();
        let queryParams = new HttpParams().set('includePermissions', String(includePermission));
        return this.http
            .get(`${this.mgmtApi}SecurityRoles/GetTemplates`, { headers: this.headers, params: queryParams })
            .pipe(catchError(this.handleError.bind(this)));
    }

    getSecurityRolePermissionById(securityRoleId?: string) {
        this.addPostAndPutHeaders();
        if (securityRoleId) {
            let queryParams = new HttpParams().set('securityRoleId', securityRoleId);
            return this.http
                .get(`${this.mgmtApi}SecurityRolePermissions`, { headers: this.headers, params: queryParams })
                .pipe(catchError(this.handleError.bind(this)));
        } else {
            return this.http.get(`${this.mgmtApi}SecurityRolePermissions`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
        }
    }

    getSecurityRolesByOrgId(orgId: string): Observable<APIRes<PermissionHierarchy[]>> {
        this.addPostAndPutHeaders();
        let queryParams = new HttpParams().set('organisationId', orgId);
        return this.http.get(`${this.mgmtApi}SecurityRoles`, { headers: this.headers, params: queryParams }).pipe(catchError(this.handleError.bind(this)));
    }

    getSecurityPermissionsForNewRole(): Observable<APIRes<PermissionActions[]>> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.mgmtApi}SecurityPermissions`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    addSecurityRole(orgId: string, securityRolePermissions: PermissionHierarchy[]): Observable<APIRes<PermissionHierarchy[]>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http
            .post(`${this.mgmtApi}securityroles/${orgId}`, securityRolePermissions, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    updateSecurityRole(orgId: string, securityRolePermissions: PermissionHierarchy[] | DeleteSecurityRole[]): Observable<APIRes<PermissionHierarchy[]>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http
            .put(`${this.mgmtApi}securityroles/${orgId}`, securityRolePermissions, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    // api call to get the default project types for instance
    getDefaultProjectTypes(): Observable<APIRes<ProjectType[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.mgmtApi}projecttypes/gettemplates`, { headers: this.headers })
            .pipe(
                tap((response: APIRes<ProjectType[]>) => {
                    this.instanceDataService.defaultProjectTypeSchema = response.response[0].schemaRevision.schema;
                })
            )
            .pipe(catchError(this.handleError.bind(this)));
    }

    // api to ge the default schema for creating a new project types
    getDefaultProjectTypeSchema(): Observable<SchemaVersion> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.mgmtApi}SchemaVersions/GetDefaultSchema`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // api call to get the project types against an instance
    getProjectTypesByInstanceId(instanceId: string): Observable<APIRes<ProjectType[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.mgmtApi}ProjectTypes/GetProjectTypes/${instanceId}`, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    // api call to save project types for instance
    saveProjectTypes(instanceId: string, projectTypes: ProjectType[]): Observable<ProjectType[]> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http
            .post(`${this.mgmtApi}projecttypes/${instanceId}`, projectTypes, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    // api call to update the project types

    updateProjectTypes(instanceId: string, projectTypes: ProjectType[] | DeleteProjectType[]): Observable<APIRes<ProjectType[]>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http
            .put(`${this.mgmtApi}projecttypes/${instanceId}`, projectTypes, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    // api call to get the project type by project type id
    getProjectTypeByProjectTypeId(projectTypeId: string): Observable<APIRes<ProjectType>> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.mgmtApi}ProjectTypes/${projectTypeId}`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // api call to get the default status types
    getDefaultStatusTypeForProject(): Observable<APIRes<ProjectTypeStatus[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.mgmtApi}ActivityPackTypes/getActivityPackTypeStatusTypes`, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    //api to get the default activity pack types
    getDefaultActivityPackTypes(): Observable<APIRes<ActivityPackType[]>> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.mgmtApi}ActivityPackTypes/GetTemplates`, { headers: this.headers }).pipe(
            tap((response: APIRes<ActivityPackType[]>) => {
                if (response.success) {
                    this.instanceDataService.defaultActivityPackSchema = response.response[0].schemaRevision.schema;
                }
            }),
            catchError(this.handleError.bind(this))
        );
    }

    // api call to save the activity pack type
    saveActivityPackType(instanceId: string, activityPackTypes: ActivityPackType[]): Observable<ActivityPackType[]> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http
            .post(`${this.mgmtApi}ActivityPackTypes/${instanceId}`, activityPackTypes, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    // api call to get activity pack type by instance id
    getActivityPackByInstanceId(instanceId: string): Observable<APIRes<ActivityPackType[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.mgmtApi}ActivityPackTypes/GetActivityPackTypes/${instanceId}`, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    // api call to update the activity pack type
    updateActivityPackType(instanceId: string, activityPackTypes: ActivityPackType[] | DeleteActivityTypesPayload[]): Observable<APIRes<ActivityPackType[]>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http
            .put(`${this.mgmtApi}activitypacktypes/${instanceId}`, activityPackTypes, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    // api call to get activityPack by id
    getActivityPackByActivityPackId(activityPackId: string): Observable<APIRes<ActivityPackType>> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.mgmtApi}ActivityPackTypes/${activityPackId}`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getFullUserDetail(user_id: string): Observable<APIRes<FullUserData>> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.mgmtApi}Users/${user_id}`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getFullUserDetailAfterLogin(): Observable<APIRes<FullUserData>> {
        this.addPostAndPutHeaders();
        return this.http.post(`${this.mgmtApi}Users/login`, {}, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // api call to get the default status types
    getDefaultStatusType(): Observable<APIRes<ActivityStatusType[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.mgmtApi}ActivityPackTypes/getActivityPackTypeStatusTypes`, { headers: this.headers })
            .pipe(
                map((response) => response),
                tap((response: APIRes<ActivityStatusType[]>) => {
                    if (response.success) {
                        this.instanceDataService.workflowStatusTypes = response.response;
                    }
                })
            )
            .pipe(catchError(this.handleError.bind(this)));
    }

    // api call to get the icons for activity pack types
    getActivityPackIcons(): Observable<APIRes<ActivityIcon[]>> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.mgmtApi}activitypacktypes/geticons`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getUserInstances(instanceId: string): Observable<APIRes<InstanceUsers>> {
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.mgmtApi}userinstances/getinstanceusers/${instanceId}`, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    postUserInstances(user: UserInstanceModel[]): Observable<APIRes<InstanceUsers>> {
        this.addPostAndPutHeaders();
        return this.http.post(`${this.mgmtApi}UserInstances`, user, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // * api call to get the json file
    getJsonFile(): Observable<Object> {
        return this.http.get('../../assets/i18n/en.json');
    }

    // * api call to sent an email (specially for contact us and page and it is an anonymousEmailApi)
    sentEmail(emailData: string): Observable<{ success: boolean }> {
        // this.addPostAndPutHeaders();
        let headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            'content-type': 'application/json',
            Accept: 'application/json',
        });
        return this.http
            .post(`${this.anonymousEmailApi}email/sendcontactusemail`, JSON.stringify(emailData), { headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    // * api call to sent an email based on any transaction
    sendEmailThroughOutWebApp(emailData: EmailModel): Observable<{ success: boolean }> {
        this.addPostAndPutHeaders();
        return this.http.post(`${this.mgmtApi}Email/SendEmail`, emailData, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //*api For getting setting Area Id for user profile
    getSettingProfileAreaId(areaName: string): Observable<APIRes<SettingArea>> {
        this.logedInUserId = this.authService?.instance?.getActiveAccount()?.idTokenClaims?.oid;
        this.addPostAndPutHeaders();
        return this.http.get(`${this.mgmtApi}settingareas/getsettingarea/${areaName}`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getSettingbySettinfAreaId(areaId): Observable<APIRes<any>> {
        this.logedInUserId = this.authService?.instance?.getActiveAccount()?.idTokenClaims?.oid;
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.mgmtApi}usersettings/getusersettings?userid=${this.logedInUserId}&settingareaid=${areaId}`, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    // * refresh token
    refreshToken() {
        return this.authService.acquireTokenSilent({
            scopes: environment.scopes,
            account: this.authService.instance.getActiveAccount(),
            authority: environment.b2cPolicies.authorities.signUpSignIn.authority,
        });
    }

    // * get Notifications
    getNotifications(): Observable<APIRes<Notifications[]>> {
        this.logedInUserId = this.authService?.instance?.getActiveAccount()?.idTokenClaims?.oid;
        this.addPostAndPutHeaders();
        this.headers = this.headers.append('Skip-Error-Dialog', `true`);
        return this.http
            .get(`${this.mgmtApi}notifications?UserId=${this.logedInUserId}&Actioned=False&NotificationType=WebNotification`, { headers: this.headers })
            .pipe(
                map((response: APIRes<Notifications[]>) => {
                    let notificationList = response.response;
                    let index = notificationList.findIndex((item) => item.notificationCheckType == 6);

                    if (index !== -1) {
                        let notificationArray = notificationList.filter((item) => item.notificationCheckType !== 6);
                        notificationArray.splice(0, 0, notificationList[index]);
                        response.response = notificationArray;
                    }
                    return response;
                }),
                catchError(this.handleError.bind(this))
            );
    }

    //Notify/ Removing Notifications
    updateNotification(notification: any[]): Observable<{ success?: boolean }> {
        this.addPostAndPutHeaders();
        return this.http.put(`${this.mgmtApi}usernotifications`, notification, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // * get communication list
    getCommunicationList(status: boolean): Observable<APIRes<Communication[]>> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.mgmtApi}notificationtemplates?Active=${status}`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
        // return this.http.get(`${this.mgmtApi}notificationtemplates`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // * manage notifications templates
    saveCommunication(communicationList: Communication[]): Observable<{ success?: boolean; isCustom?: boolean; message?: string }> {
        this.addPostAndPutHeaders();
        return this.http
            .put(`${this.mgmtApi}notificationtemplates`, communicationList, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    updateCurrentUser(organizationUser): Observable<APIRes<User[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .put(`${this.mgmtApi}users/updatecurrentuser`, organizationUser, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    getViewTemplates(): Observable<APIRes<ViewDto[]>> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.mgmtApi}views/GetViewTemplates`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    GetHierarchyTemplates(AssetTypeID: any): Observable<APIRes<HierarchyViewModel[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.mgmtApi}views/GetHierarchyTemplates/` + AssetTypeID, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    GetHierarchyTemplatesByInstance(instanceId: any): Observable<APIRes<HierarchyViewModel[]>> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.mgmtApi}views/GetViews/` + instanceId, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    updateIdmsView(instanceId: string, View: any): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();

        return this.http.put(`${this.mgmtApi}Views/${instanceId}`, View, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    addIdmsView(instanceId: string, View: any): Observable<APIRes<any>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http.post(`${this.mgmtApi}Views/${instanceId}`, View, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    updateInstanceSettings(obj): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http
            .put(`${this.mgmtApi}instancesettings/updateinstancesettings`, obj, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }
    //gettingInstanceSettings
    getInstanceSettings(areaId: string, instanceId: string): Observable<APIRes<InstanceSettings[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.mgmtApi}instancesettings/getinstancesettings/?instanceid=${instanceId}&settingareaid=${areaId}`, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    //gettingInstanceSettings
    getInstanceDefaultSettings(areaId: string, instanceId: string): Observable<APIRes<DefaultInstanceSettings[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.mgmtApi}instancesettings/getinstancedefaults/?instanceid=${instanceId}&settingareaid=${areaId}`, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    // * api call to get the line number template
    getLineNumberTemplate(): Observable<APIRes<LineNumberFormat[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.mgmtApi}LineNumberFormats/GetLineNumberFormatTemplates`, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    // * api call to get the line number format sections types
    getLineNumberFormatSectionTypes(): Observable<APIRes<LineNumberFormatSectionType[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.mgmtApi}linenumberformats/getlinenumberformatsectiontypes`, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    // * api call to get the line number format using instance id
    getLineNumberFormatByInstance(instanceId: string): Observable<APIRes<LineNumberFormat[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.mgmtApi}linenumberformats/getlinenumberformats/${instanceId}`, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    // * api  call to save the line number format
    saveLineNumberFormat(instanceId: string, lineNumberFormatPayload: LineNumberFormat[]): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http
            .put(`${this.mgmtApi}linenumberformats/${instanceId}`, lineNumberFormatPayload, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    // * api call to save the system maintenance notification
    saveSystemMaintenanceNotification(systemNotifications: SystemMaintenanceModel[]): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http.post(`${this.mgmtApi}notifications`, systemNotifications, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //***************API Call to get Schema versions************************** */
    GetSchemaVersions(schemaVersionId: any, instanceId: string): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        this.headers = this.headers.append('instanceid', instanceId);
        return this.http.get(`${this.mgmtApi}schemaversions/` + schemaVersionId, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }
    //For update settings
    getSettingbySettinfAreaIdForIdms(areaId): Observable<APIRes<any>> {
        this.logedInUserId = this.authService?.instance?.getActiveAccount()?.idTokenClaims?.oid;
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http
            .get(`${this.mgmtApi}instancesettings/getinstancesettings?instanceid=${localStorage.getItem('currentInstanceId')}&settingareaid=${areaId}`, {
                headers: this.headers,
            })
            .pipe(catchError(this.handleError.bind(this)));
    }

    updatePassPercentageSettings(settings: any[]): Observable<{ success: boolean; isCustom?: boolean; message?: string; response?: SettingModel[] }> {
        const url = `${this.mgmtApi}instancesettings/UpdateInstanceSettings/`;
        const inputMsg = JSON.stringify(settings);
        this.addPostAndPutHeaders();

        return this.http.put(url, inputMsg, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //* GET Default Activity Tag Standerd API
    getDefaultActivityTagStandard(instanceId): Observable<{ success?: boolean; isCustom?: boolean; message?: string; response?: ActivityTagStandard[] }> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.mgmtApi}tagstandards/` + instanceId, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getActivityPackByInstanceIdWithTaggedItemLocal(
        isTaggedItemLocal: boolean
    ): Observable<{ success?: boolean; isCustom?: boolean; message?: string; response?: ActivityPackType[] }> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http
            .get(`${this.mgmtApi}ActivityPackTypes/GetActivityPackTypes/${localStorage.getItem('currentInstanceId')}`, {
                headers: this.headers,
                params: new HttpParams().set('isTaggedItemLocal', isTaggedItemLocal),
            })
            .pipe(catchError(this.handleError.bind(this)));
    }
    //Method for getting report List by Instance
    getReportListByInstance(instanceId: string): Observable<APIRes<ReportList[]>> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.mgmtApi}reports/getreports/${instanceId}`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //Method for getting report List by Instance
    getreporttemplates(): Observable<APIRes<ReportList[]>> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.mgmtApi}reports/getreporttemplates`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // * api call to save the instance reports
    postInstancereports(data: ReportList[], instanceId: string): Observable<{ success?: boolean; isCustom?: boolean; message?: string }> {
        this.addPostAndPutHeaders();
        return this.http.post(`${this.mgmtApi}reports/${instanceId}`, data, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // * api call to update instance reports
    putInstancereports(data: ReportList[], instanceId: string): Observable<{ success?: boolean; isCustom?: boolean; message?: string }> {
        this.addPostAndPutHeaders();
        return this.http.put(`${this.mgmtApi}reports/${instanceId}`, data, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    addUsersessionDetails(user: UserSessions): Observable<UserSessions> {
        this.addPostAndPutHeaders();
        return this.http.post(`${this.mgmtApi}users/AddUserSessions`, user, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    checkUserSessionIsActive(user: UserSessions): Observable<APIRes<UserSessions>> {
        this.addPostAndPutHeaders();
        return this.http
            .post<UserSessions>(`${this.mgmtApi}users/CheckUserSessionIsActive`, user, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    changeStatusForLogOut(user: UserSessions): Observable<APIRes<UserSessions>> {
        this.addPostAndPutHeaders();
        return this.http
            .post<UserSessions>(`${this.mgmtApi}users/LogoutFromOtherInstance`, user, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    logoutCurrentUser(user: UserSessions): Observable<APIRes<UserSessions>> {
        this.addPostAndPutHeaders();
        return this.http
            .post<UserSessions>(`${this.mgmtApi}users/LogoutCurrentInstance`, user, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    getusersforinstanceallocation(instanceId) {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
        return this.http
            .get(`${this.mgmtApi}userinstances/getusersforinstanceallocation/${instanceId}`, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    //Method for getting activitypacktypestatusfunctions
    getactivitypacktypestatusfunctions(): Observable<APIRes<Activitypacktypestatusfunctions[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.mgmtApi}activitypacktypes/getactivitypacktypestatusfunctions`, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }
    //Method for getting report List by Instance
    getSubscriptionsByReports(reportId: string): Observable<APIRes<any[]>> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.mgmtApi}subscriptions/${reportId}`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }
    //Method for getting report List by Instance
    getFileTypes(): Observable<APIRes<any[]>> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.mgmtApi}subscriptions/getfiletypes`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }
    //***************API Call to post subscriptions************************** */
    postSubscriptions(reportId: string, params: any): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http.post(`${this.mgmtApi}subscriptions/${reportId}`, params, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }
    //***************API Call to delete subscriptions************************** */
    deleteSubscription(data: any, reportId): Observable<APIRes<SettingModel[]>> {
        this.addPostAndPutHeaders();
        return this.http.put(`${this.mgmtApi}subscriptions/${reportId}`, data, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }
    //***************API Call to post subscriptions************************** */
    putSubscriptions(reportId: string, params: any): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http.put(`${this.mgmtApi}subscriptions/${reportId}`, params, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }
    //***************API Call to delete subscriptions************************** */
    sendReportImmediately(data: any): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http
            .put(`${this.mgmtApi}subscriptions/updaterunimmediately`, data, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }
    //***************API Call to delete subscriptions************************** */
    enableSubscription(data: any): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http
            .put(`${this.mgmtApi}subscriptions/updatescheduleenabled`, data, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    //***************API Call to get Upload History************************** */
    getUploadHistory(): Observable<APIRes<any[]>> {
        const url = `${this.mgmtApi}uploads/${localStorage.getItem('currentInstanceId')}`; //`
        this.addPostAndPutHeaders();

        return this.http.get(url, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //***************API Call to get get Documentviews ************************** */
    getdocumentviews(): Observable<APIRes<ViewType[]>> {
        const url = `${this.mgmtApi}views/getdocumentviews/${localStorage.getItem('currentInstanceId')}`; //`
        this.addPostAndPutHeaders();

        return this.http.get(url, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //***************API Call to defualt taggeditemtypes ************************** */
    taggeditemtypes(): Observable<APIRes<TaggedItemType[]>> {
        const url = `${this.mgmtApi}taggeditemtypes`; //`
        this.addPostAndPutHeaders();

        return this.http.get(url, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //***************API Call to get getApprovalLookUps************************** */
    getApprovalLookUps(lookup: any, trigger?: any): Observable<APIRes<any[]>> {
        let url = `${this.mgmtApi}approvalrules/getapprovallookups?lookupType=${lookup}`; //`
        if (trigger && lookup == 2) {
            url = `${this.mgmtApi}approvalrules/getapprovallookups?lookupType=${lookup}&trigger=${trigger}`; //`
        }
        if (lookup == 3) {
            url = `${this.mgmtApi}approvalrules/getapprovallookups?lookupType=${lookup}&instanceId=${localStorage.getItem('currentInstanceId')}`; //`
        }
        this.addPostAndPutHeaders();

        return this.http.get(url, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    saveRules(obj): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http
            .post(`${this.mgmtApi}approvalrules/${localStorage.getItem('currentInstanceId')}`, obj, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    getRules(): Observable<APIRes<any>> {
        const url = `${this.mgmtApi}approvalrules/${localStorage.getItem('currentInstanceId')}`; //`
        this.addPostAndPutHeaders();

        return this.http.get(url, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    updateRules(obj): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http
            .put(`${this.mgmtApi}approvalrules/${localStorage.getItem('currentInstanceId')}`, obj, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    deleteRules(obj): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http
            .put(`${this.mgmtApi}approvalrules/${localStorage.getItem('currentInstanceId')}`, obj, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }
    getDeliveryGroups(): Observable<APIRes<any>> {
        const url = `${this.mgmtApi}deliverygroups/${localStorage.getItem('currentInstanceId')}`; //`
        this.addPostAndPutHeaders();

        return this.http.get(url, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }
    saveDeliveryGroup(payload?: ApprovalDeliveryGroupModel[]): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http
            .post(`${this.mgmtApi}deliverygroups/${localStorage.getItem('currentInstanceId')}`, payload, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }
    getusersfordeliverygroupallocation(): Observable<APIRes<any>> {
        const url = `${this.mgmtApi}userdeliverygroups/getusersfordeliverygroupallocation/${localStorage.getItem('currentInstanceId')}`; //`
        this.addPostAndPutHeaders();

        return this.http.get(url, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }
    updateDeliveryGroup(payload?: ApprovalDeliveryGroupModel[]): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http
            .put(`${this.mgmtApi}deliverygroups/${localStorage.getItem('currentInstanceId')}`, payload, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }
}
